export const REMINDERS_COLUMNS = {
  reminder_type: {
    header: 'Type',
    group: 'Reminder Details',
  },
  run_at: {
    header: 'Scheduled Date/Time',
    group: 'Reminder Details',
  },
  title: {
    header: 'Title',
    group: 'Reminder Details',
  },
  content: {
    header: 'Content',
    group: 'Reminder Details',
  },
  status: {
    header: 'Status',
    group: 'Reminder Details',
  },
  contact_company: {
    header: 'Related Company',
    group: 'Related Data',
  },
  door_proxy: {
    header: 'Related Location',
    group: 'Related Data',
  },
  deals: {
    header: 'Related Deals',
    group: 'Related Data',
  },
  recipients: {
    header: 'Recipients',
    group: 'Recipients',
  },
  recipients_count: {
    header: 'Recipients Count',
    group: 'Recipients',
  },
  created_by: {
    header: 'Created By',
    group: 'Metadata',
  },
  created: {
    header: 'Date Created',
    group: 'Metadata',
  },
  modified: {
    header: 'Last Modified',
    group: 'Metadata',
  },
  timezone: {
    header: 'Timezone',
    group: 'Metadata',
  },
  last_sent_at: {
    header: 'Last Sent',
    group: 'Execution',
  },
  next_run_at: {
    header: 'Next Run',
    group: 'Execution',
  },
}
